const routePaths = {
  root: '/',
  rootLogged: '/',
  login: '/login',
  auth: {
    forgotPassword: '/forgot-password',
    forgotPasswordConfirmation: '/forgot-password/confirmation',
    setPassword: '/set-password/:token',
    setPasswordConfirmation: '/set-password/confirmation',
    setNewUserPassword: '/set-new-user-password/:token',
  },
  cabinets: {
    main: '/cabinets',
    new: '/cabinets/new',
    edit: '/cabinets/:id/edit',
    assign: '/cabinets/:id/assign',
    assigned: '/cabinets/assigned',
    unassigned: '/cabinets/unassigned',
  },
  datasets: {
    main: '/datasets',
    assignedTask: '/datasets/assigned-task',
  },
  terminals: {
    main: '/terminals',
    find: '/terminals/:id',
    edit: '/terminals/:id/edit',
    create: '/terminals/:id/create',
  },
  fallback: {
    main: '/fallback',
    validationProfiles: '/fallback/validation-profiles',
    createValidationProfile: '/fallback/validation-profiles/new',
    editValidationProfile: '/fallback/validation-profiles/:id/edit',
    fallbackUsers: '/fallback/fallback-users',
    editFallbackUser: '/fallback/fallback-users/:id/edit',
    sessions: '/fallback/sessions',
  },
  productQa: {
    main: '/product-qa',
    edit: '/product-qa/:id/edit',
    dataset: '/product-qa/:id/dataset',
  },
  profile: {
    edit: '/profile/edit',
  },
  storeProject: {
    main: '/store-project',
    new: '/store-project/new',
    edit: '/store-project/:id/edit',
  },
  senseiUsers: {
    main: '/sensei-users',
    create: '/sensei-users/new',
    edit: '/sensei-users/:id/edit',
  },
  planogram: {
    main: '/planogram',
    tasks: '/planogram/tasks',
    assignedTask: '/planogram/assigned-task',
    validatedTasks: '/planogram/validated-tasks',
    validatedTaskDetail: '/planogram/validated-tasks/:id',
  },
};

export default routePaths;
